import logo from './logo.svg';
import './App.css';
import Home from './Components/Home';
import AllRoutes from './Components/AllRoutes';
import NewArrivals from './Components/NewArrivals';

function App() {
  return (
    <div className="App">
      <AllRoutes/>
      
    </div>
  );
}

export default App;
